export async function loadGoogleMapsPlaceSDK(explicitKey?: string): Promise<void> {
  if (typeof window === 'undefined') return;
  // If already loaded, resolve
  if ((window as any).google && (window as any).google.maps && (window as any).google.maps.places) {
    // eslint-disable-next-line no-console
    console.debug('[loadGoogleMapsPlaceSDK] Google Maps Places already available');
    return;
  }

  // Read API key from argument or Vite env. Do not hardcode keys in source for production.
  let key = explicitKey;
  if (!key) key = (import.meta as any).env?.VITE_GOOGLE_MAPS_API_KEY;
  if (!key) {
    // No key provided — resolve but don't load SDK. Caller should handle absence.
    // eslint-disable-next-line no-console
    console.debug('[loadGoogleMapsPlaceSDK] No API key provided (explicit or VITE_GOOGLE_MAPS_API_KEY); skipping load');
    return;
  }

  // If a script tag already exists with google sdk, wait for it to load
  const existing = Array.from(document.getElementsByTagName('script')).find((s) => s.src.includes('maps.googleapis.com')) as HTMLScriptElement | undefined;
  if (existing) {
    // eslint-disable-next-line no-console
    console.debug('[loadGoogleMapsPlaceSDK] Found existing Google Maps script tag; waiting for it');
    if ((window as any).google && (window as any).google.maps && (window as any).google.maps.places) return;
    // wait for load
    await new Promise<void>((resolve, reject) => {
      existing.addEventListener('load', () => {
        // eslint-disable-next-line no-console
        console.debug('[loadGoogleMapsPlaceSDK] Existing script loaded');
        resolve();
      });
      existing.addEventListener('error', () => {
        // eslint-disable-next-line no-console
        console.warn('[loadGoogleMapsPlaceSDK] Existing script failed to load');
        resolve();
      });
      // fallback timeout
      setTimeout(() => resolve(), 5000);
    });
    return;
  }

  const src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(key)}&libraries=places&loading=async`;
  const script = document.createElement('script');
  script.src = src;
  script.async = true;
  script.defer = true;
  // eslint-disable-next-line no-console
  console.debug('[loadGoogleMapsPlaceSDK] Injecting Google Maps script', src.replace(/key=[^&]+/, 'key=REDACTED'));
  document.head.appendChild(script);

  await new Promise<void>((resolve) => {
    script.addEventListener('load', () => {
      // eslint-disable-next-line no-console
      console.debug('[loadGoogleMapsPlaceSDK] Google Maps script loaded');
      resolve();
    });
    script.addEventListener('error', () => {
      // eslint-disable-next-line no-console
      console.warn('[loadGoogleMapsPlaceSDK] Google Maps script failed to load');
      resolve();
    });
    // safety timeout (resolve anyway)
    setTimeout(() => resolve(), 7000);
  });
}
